module.exports = __webpack_public_path__ + "img/A1932.64ecb900.png";